<template lang="pug">
.card
	.card-header.bg-warning
		span.fa.fa-camera.mr-2
		| Imágenes y vídeos
	div.text-danger.text-center(v-if="texto.Imagenes.length === 0", style="font-size:1.3em;font-weight:bold;")
		| No hay imágenes asociadas
	div(v-else)
		.contieneImagenes
			div.imagen(
				v-for="img in texto.Imagenes"
				:key="img.ImagenID"
				style="position:relative;margin:2px;width:150px;cursor:pointer;height:150px;background-size:cover;background-position:center;background-repeat:no-repeat;"
				:style="{'background-image': 'url(src/modulos/galerias/php/api/thumb.php?ItemID=' + img.ItemID + ')'}"
				@click="verItem = img.ItemID"
			)
				button.btn.btn-danger(@click="delImagen($event, img.ItemID)", style="position:absolute;bottom:5px;right:5px;", v-if="!readonly")
					span.fa.fa-trash
	div.text-center.m-2(v-if="!readonly")
		button.btn.btn-sm.btn-primary(@click="buscador = true")
			span.fa.fa-plus.mr-2
			| Adjuntar imágenes
	//
		.card-header.bg-dark.text-white(@click="verSugerencias = !verSugerencias", style="cursor:pointer")
			span.fa.fa-info-circle.mr-2
			span(v-if="verSugerencias") Ocultar sugerencias
			span(v-else) Ver sugerencias
			span  ({{sugerencias.length}})
			button.close
				span.fa.text-white(:class="(verSugerencias) ? 'fa-caret-up' : 'fa-caret-down'")
		div(v-if="verSugerencias")
			.contieneImagenes
				div(
					v-for="img in sugerencias"
					:key="img.ItemID"
					style="margin:2px;width:150px;cursor:pointer;height:150px;background-size:cover;background-position:center;background-repeat:no-repeat;"
					:style="{'background-image': 'url(src/modulos/galerias/php/api/thumb.php?ItemID=' + img.ItemID + ')'}"
					@click="addImagen(img.ItemID)"
				)
	VisorItem(v-if="verItem", :item-id.sync="verItem", @cerrar="verItem = null", :listado="listadoItemID")
	BuscadorImagenes(v-if="buscador", @cerrar="buscador = null", @adjuntar="adjuntar($event)")
</template>

<script>
import axios from 'axios'
import BuscadorImagenes from './buscadorImagenes'
import VisorItem from '../../../../galerias/vue/componentes/visor-item/visor-item.vue'
export default {
	props: ['texto', 'palabrasClave', 'readonly'],
	components: {
		VisorItem,
		BuscadorImagenes
	},
	data () {
		return {
			sugerencias: [],
			ultimaBusqueda: null,
			intervalo: null,
			verSugerencias: false,
			modificado: true,
			ultimo: null,
			verItem: null,
			buscador: null
		}
	},
	created () {
		if (this.palabrasClave.length > 0) {
			// this.buscarSugerencias()
		}
	},
	watch: {
		'palabrasClave': function (newVal) {
			this.modificado = true

			if (!this.ultimo || new Date().getTime() - this.ultimo > 5000) {
				this.ultimo = new Date().getTime()
				// this.buscarSugerencias()
			}
		}
	},
	computed: {
		listadoItemID () {
			if (!this.texto.Imagenes) {
				return []
			}
			return this.texto.Imagenes.map(i => {
				return i.ItemID
			})
		},
		palabras () {
			const arr = Array.from(this.palabrasClave)
			arr.sort((a, b) => {
				if (a[1] > b[1]) {
					return -1
				} else if (a[1] === b[1]) {
					return 0
				} else {
					return 1
				}
			})
			return arr
		}
	},
	mounted () {
		this.intervalo = window.setInterval(() => {
			// this.buscarSugerencias()
		}, 10000)
	},
	beforeDestroy () {
		window.clearInterval(this.intervalo)
	},
	methods: {
		buscarSugerencias () {
			if (!this.modificado) {
				return
			}
			if (!this.palabras || this.palabras.length < 5) {
				return
			}
			const cadena = this.palabras.reduce((ant, val) => {
				ant = ant + ' ' + val[0]
				return ant
			}, '')
			this.ultimaBusqueda = new Date().getTime()
			axios.post('galerias/php/api/buscador.php', {cadena: cadena})
				.then(res => {
					this.sugerencias = res.data.items
					this.modificado = false
				})
				.catch(e => {
					console.error(e.response)
				})
		},
		adjuntar (items) {
			const form = {
				NoticiaID: this.texto.NoticiaID,
				ItemID: items
			}
			axios.post('redaccion/php/api/add-imagen.php', form)
				.then(res => {
					this.texto.Imagenes = res.data
				})
				.catch(this.$responseError)
		},
		addImagen (ItemID) {
			const form = {
				NoticiaID: this.texto.NoticiaID,
				ItemID: ItemID
			}

			axios.post('redaccion/php/api/add-imagen.php', form)
				.then(res => {
					this.texto.Imagenes = res.data
				})
				.catch(this.$responseError)
		},
		delImagen (ev, ItemID) {
			ev.preventDefault()
			ev.stopPropagation()
			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar',
				mensaje: `¿Quieres eliminar esta imagen de esta noticia?`,
				callback: acepta => {
					if (acepta) {
						const form = {
							NoticiaID: this.texto.NoticiaID,
							ItemID: ItemID
						}
						axios.post('redaccion/php/api/del-imagen.php', form)
							.then(() => {
								for (let i = 0; i < this.texto.Imagenes.length; i++) {
									if (this.texto.Imagenes[i].ItemID === ItemID) {
										this.texto.Imagenes.splice(i, 1)
										return
									}
								}
							})
							.catch(this.$responseError)
					}
				}
			})
		}
	}
}
</script>

<style scoped>
.contieneImagenes {
	display: flex;
	flex-direction: rows;
	flex-wrap: wrap;
	align-content: stretch;
	align-items: stretch;
	align-self: stretch;
	margin: 0;
	width: 100%;
}

.imagen > button{
	display: block;
	opacity: 0;
	transition: opacity 0.3s;
}

.imagen:hover > button {
	opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/modulos/redaccion/vue/componentes/editor/imagenes.vue